<template>
  <div
    :class="[
      'asc-global-filter-button',
      filterDisabled ? 'asc-global-filter-button--disabled' : '',
    ]"
  >
    <asc-tooltip bottom :tooltip="getTooltip" :tooltip-length="0">
      <asc-accent-button
        :on-click="onClick"
        :button-text="buttonText"
        :disabled="filterDisabled"
        secondary
        :icon="getButtonIcon"
        icon-position="right"
        :class="[
          filterEnabled && filterActive
            ? 'asc-global-filter-button--enabled-active'
            : '',
          filterEnabled && !filterActive
            ? 'asc-global-filter-button--enabled'
            : '',
        ]"
      ></asc-accent-button>
    </asc-tooltip>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscGlobalFilterButton',

  components: {
    AscAccentButton,
    AscTooltip,
  },

  props: {
    buttonText: {
      type: String,
      default: '',
    },
    buttonTooltip: {
      type: String,
      default: '',
    },
    onClick: {
      type: Function,
      default: () => {},
    },
    filterActive: {
      type: Boolean,
      default: false,
    },
    filterEnabled: {
      type: Boolean,
      default: false,
    },
    filterDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getTooltip() {
      return this.filterDisabled || !this.filterActive ? this.buttonTooltip : ''
    },

    getButtonIcon() {
      return this.filterActive ? 'mdi-filter' : 'mdi-eye-off'
    },
  },
}
</script>

<style lang="scss">
.asc-global-filter-button {
  margin: 4px 16px 0 16px;

  &--enabled-active {
    .asc-accent-button--accent .v-btn__content .v-icon--right {
      color: $accent-600 !important;
    }
  }

  &--enabled {
    .asc-accent-button--accent .v-btn__content .v-icon--right {
      color: $primary-black !important;
    }
  }
}

.asc-global-filter-button--disabled {
  cursor: not-allowed !important;

  .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--text):not(.v-btn--outline) {
    background-color: transparent !important;

    .v-btn__content {
      color: $primary-black !important;
    }
  }
}
</style>
